export default function getCurrentUrl(): string {
    const location = window.location;

    const url = new URL(location.href);

    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
        url.port = location.port;
    }

    return url.toString();
}
